import { Component, inject, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { AppIcon } from '@base/models/enums/app.icons';
import { ModuleMedia } from '@models/classes/module-media.model';
import { FileType } from '@models/enums/file-type.enum';
import { BaseBlockComponent } from '@shared/blocks/block/base-block.component';
import { IMediaBlockData, MediaUploadModalComponent } from '@shared/blocks/modals/media-upload-modal/media-upload-modal.component';
import { BlockEmbedded } from '@shared/blocks/models/block.model';
import { IResizableResult } from '@shared/components/resizable-element/resizable-element.component';
import { ModalService } from '@shared/modal/modal.service';

@Component({
  selector: 'app-block-embedded',
  templateUrl: './block-embedded.component.html',
  styleUrls: ['./block-embedded.component.scss']
})
export class BlockEmbeddedComponent extends BaseBlockComponent<BlockEmbedded> implements OnChanges {
  readonly placeholder: string = 'MODULES.EMBEDDED_BLOCK_PLACEHOLDER';
  readonly AppIcon = AppIcon;

  private readonly _modalService: ModalService = inject(ModalService);
  private readonly _sanitizer: DomSanitizer = inject(DomSanitizer);

  safeUrl: SafeResourceUrl;

  override ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes.block) {
      this._refreshMediaUrl();
    }
  }

  handleSizeChange({ height }: IResizableResult): void {
    this.block.height = height;
    this.save();
  }

  saveSetting(): void {
    this.block.styleSettings = this.updatedStyleSettings;
    this.segment.cql = this.updatedCqlSettings.cql;
    this.segment.isInPlaybook = this.updatedPlaybookSettings.isInPlaybook;
    this.save();
  }

  override openDialog(e: Event): void {
    super.openDialog(e);

    this._modalService
      .open<IMediaBlockData>(
        {
          component: MediaUploadModalComponent,
          context: {
            entity: {
              id: this.block.id,
              type: FileType.embed
            }
          }
        },
        {
          maxWidth: '53rem',
          panelClass: 'no-actions'
        }
      )
      .subscribe((result: IMediaBlockData): void => {
        this.block.fileId = result.media.id;
        this.block.fileUrl = result.media.src;
        this._setSafeUrl(this.block.fileUrl);
        this.save();
      });
  }

  private _refreshMediaUrl(): void {
    if (this.block.fileId) {
      this.getMediaSignedUrl(this.block.fileId).subscribe((res: ModuleMedia): void => {
        this.block.fileUrl = res.src;
        this._setSafeUrl(this.block.fileUrl);
      });
    } else {
      this._setSafeUrl(this.block.fileUrl);
    }
  }

  private _setSafeUrl(unsafe: string): void {
    this.safeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(unsafe);
  }
}
